module.exports = __webpack_public_path__ + "static/media/vodafone-light.a71ea068.woff";